/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/FrisbiiPayment/theme';

export const FrisbiiPaymentTheme = theme;
